export const ASSETS_BASE_URL = "https://api1-rewirpower.atino.net/uploads/images/";
